import { useEffect } from 'react';
import backgroundVideoCache from '../services/BackgroundVideoCache';

// Hook to preload background videos early in the app lifecycle
export const useBackgroundVideoPreloader = () => {
  useEffect(() => {
    // Preload on component mount with a small delay to not block initial render
    const preloadTimer = setTimeout(() => {
      backgroundVideoCache.preloadFirstPage().catch(error => {
        console.error('Failed to preload background videos:', error);
      });
    }, 1000); // 1 second delay

    return () => clearTimeout(preloadTimer);
  }, []);
};

export default useBackgroundVideoPreloader; 